module.exports = __webpack_public_path__ + "img/bg_zanghaomianfei.8ddab8f9.png";